import { FaShoppingCart } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { setIsCartOpen } from "../../../redux/features/cartState";

const FloatingCartButton = () => {
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart?.cart) ?? [];
  const count = cart.length;
  const hasItems = count > 0;

  return (
    <div className="fixed bottom-10 right-6 z-[60]">
      {/* Outer red halo */}
      <div
        className={`p-[2px] rounded-full transition-transform duration-300 ${
          hasItems
            ? "bg-gradient-to-br from-red-500 via-rose-500 to-red-600"
            : "bg-gradient-to-br from-gray-300 via-gray-400 to-gray-500 dark:from-gray-700 dark:via-gray-600 dark:to-gray-500"
        }`}
      >
        {/* Button */}
        <button
          aria-label="Open cart"
          onClick={() => dispatch(setIsCartOpen())}
          className="relative flex items-center gap-2 rounded-full px-4 py-3 backdrop-blur-md
                     bg-white/90 dark:bg-neutral-900/80 shadow-lg ring-1 ring-black/5 dark:ring-white/10
                     transition-all duration-300 hover:translate-y-[-2px] active:translate-y-0 group"
        >
          {/* Icon chip */}
          <span
            className={`grid place-items-center rounded-full w-9 h-9 text-white shadow-md
                        bg-gradient-to-br from-red-500 to-red-600 ${
                          hasItems ? "animate-pulse" : ""
                        }`}
          >
            <FaShoppingCart className="text-base" />
          </span>

          {/* Label (shows on sm+) */}
          <span className="hidden sm:block text-sm font-semibold tracking-wide text-neutral-800 dark:text-neutral-200">
            {hasItems ? "Your cart • Review" : "Cart"}
          </span>

          {/* Count badge */}
          {hasItems && (
            <>
              <span className="absolute -top-1 -right-1 inline-flex items-center justify-center w-5 h-5 text-[10px] font-bold text-white bg-red-500 rounded-full shadow-md animate-bounce">
                {count}
              </span>
              <span className="absolute -top-1 -right-1 inline-flex h-5 w-5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-40"></span>
              </span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default FloatingCartButton;
